namespace Areas.Ucla.List {
    "use strict";

    export function editLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.daUclaId; },
            "<a href= '/Ucla/Detail/Index/{placeholder}'>Edit</a>");
    }

    export function showCreate() {
        const createDaUclaDialog = new Areas.Dialogs.CreateDaUclaDialog(() => { });
    }
    
}